import { render, staticRenderFns } from "./ContactAndGroupManagement.vue?vue&type=template&id=3d0161dd&"
import script from "./ContactAndGroupManagement.vue?vue&type=script&lang=js&"
export * from "./ContactAndGroupManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports